// Valida o DV geral do código de barras de boleto (posição 5, padrão
// FEBRABAN, módulo 11) — gate de segurança antes de habilitar a impressão.
// Não recalcula nem altera o dado; só confirma que o dígito bate.
const PESOS = [2, 3, 4, 5, 6, 7, 8, 9];

export default function isValidBarcodeDV(codigoBarras) {
  const codigo = String(codigoBarras || '').trim();
  if (!/^\d{44}$/.test(codigo)) return false;

  const dvInformado = Number(codigo[4]);
  const semDV = codigo.slice(0, 4) + codigo.slice(5);

  let soma = 0;
  for (let i = 0; i < semDV.length; i += 1) {
    const digito = Number(semDV[semDV.length - 1 - i]);
    const peso = PESOS[i % PESOS.length];
    soma += digito * peso;
  }

  const resto = soma % 11;
  let dvCalculado = 11 - resto;
  if (dvCalculado === 0 || dvCalculado === 10 || dvCalculado === 11) {
    dvCalculado = 1;
  }

  return dvCalculado === dvInformado;
}
